/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Comparison_Product_Hunt_TitleInputs */

const en_directory_comparison_product_hunt_title = /** @type {(inputs: Directory_Comparison_Product_Hunt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A different path to product discovery`)
};

const zh_directory_comparison_product_hunt_title = /** @type {(inputs: Directory_Comparison_Product_Hunt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`另一条产品发现路径`)
};

/**
* | output |
* | --- |
* | "A different path to product discovery" |
*
* @param {Directory_Comparison_Product_Hunt_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_comparison_product_hunt_title = /** @type {((inputs?: Directory_Comparison_Product_Hunt_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Comparison_Product_Hunt_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_comparison_product_hunt_title(inputs)
	return zh_directory_comparison_product_hunt_title(inputs)
});
export { directory_comparison_product_hunt_title as "directory.comparison.product_hunt.title" }